import React, { Component }            from 'react';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import { Redirect }                    from 'react-router-dom';
import EmployeeOnboardingBreadcrumb    from './Breadcrumb';
import Home                            from './admin/Home';
import Requests                        from './admin/requests/Requests';
import Responses                       from './admin/Responses';
import Add                             from './admin/add/Add';
import DoorAccess                      from './user/DoorAccess';
import Approve                         from './approve/Approve';
import Remove                          from './approve/Remove';
import Notify                          from './approve/Notify';
import { EmployeeOnboardingConstants } from './environment';
import Required                        from '../../Required';
import { isLoggedIn }                  from '../../../utils/authService';
import { isInRoleFromToken }           from '../../../utils/authService';
import { redirect }                    from '../../../utils/authService'; 

class EmployeeOnboarding extends Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | Account Access';
  }

  render() {
    var path = this.props.location.pathname.toLowerCase();    
    if (!isLoggedIn()) {
      redirect(window.location.hash.replace("#/", ""));
      return (
        <Required />
      );
    }
        
    let content = null;
    if (path.startsWith(EmployeeOnboardingConstants.ApprovePathPrefix)) {
      content = <Approve />;
    }
    else if (path.startsWith(EmployeeOnboardingConstants.RemovePathPrefix)) {
      content = <Remove />;
    }
    else if (path.startsWith(EmployeeOnboardingConstants.NotifyPathPrefix)) {
      content = <Notify />;
    }
    else if (isInRoleFromToken(EmployeeOnboardingConstants.AdminRole)) {
      let component = null;
      if (path.endsWith(EmployeeOnboardingConstants.PathPrefix)) {
        component = <Requests />;
      }
      else if (path.startsWith(EmployeeOnboardingConstants.AdminPathPrefix + '/home') || path === EmployeeOnboardingConstants.PathPrefix) {
        component = <Home />;
      }
      else if (path.startsWith(EmployeeOnboardingConstants.AdminPathPrefix + '/requests')) {
        component = <Requests />;
      }
      else if (path.startsWith(EmployeeOnboardingConstants.AdminPathPrefix + '/responses')) {
        component = <Responses />;
      }
      else if (path.startsWith(EmployeeOnboardingConstants.AdminPathPrefix + '/add')) {
        component = <Add />;
      }
      else if (path.startsWith(EmployeeOnboardingConstants.UserPathPrefix + '/door')) {
        component = <DoorAccess />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <EmployeeOnboardingBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else if (isInRoleFromToken(EmployeeOnboardingConstants.DoorRole)) {
      let component = null;
      if (path.endsWith(EmployeeOnboardingConstants.PathPrefix)) {
        component = <DoorAccess />;
      }
      else if (path.startsWith(EmployeeOnboardingConstants.UserPathPrefix + '/door')) {
        component = <DoorAccess />;
      }
      else {
         // No idea what path here
      }
      
      content = 
        <div>
          <EmployeeOnboardingBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else if (EmployeeOnboardingConstants.UserRole === "*" || isInRoleFromToken(EmployeeOnboardingConstants.UserRole)) {
      let component = null;
      if (false) {
        
      }
      else {
         // No idea what path here
      }
      
      content = 
        <div>
          <EmployeeOnboardingBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else {
      return <Redirect to='/404' />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  employee: state.employee
});

export default withRouter(connect(mapStateToProps)(EmployeeOnboarding));
